import type { CSSProperties } from 'react';
import { color } from './tokens';

export type ShellVariant = 'console' | 'portal';

/** Style for one sidebar link. */
export function navItemStyle(variant: ShellVariant, active: boolean): CSSProperties {
  const base: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    minHeight: 40,
    padding: '0 12px',
    borderRadius: 8,
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
  };
  if (variant === 'console') {
    return active
      ? { ...base, background: color.consoleNavActiveBg, color: color.consoleNavActiveText }
      : { ...base, color: color.consoleNavText };
  }
  return active
    ? { ...base, background: color.portalNavActiveBg, color: color.portalNavActiveText }
    : { ...base, color: color.portalNavText };
}
